<div class="right-side p-2">
  <h2 class="mt-4">Response for Expression of Interest (EoI)</h2>
  <div class="section">
    <form [formGroup]="frmEOIList">
      <div class="row">
        <div class="text-end">
          <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
          <button (click)="exportToPDF()" type="button" class="btn btn-sm btn-primary">Export to PDF</button>         
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>From Date</mat-label>
            <input matInput [matDatepicker]="fromPicker" formControlName="fromDate" placeholder="Enter from date">
            <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>To Date</mat-label>
            <input matInput [matDatepicker]="toPicker" formControlName="toDate" placeholder="Enter to date">
            <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-6 search-container">
          <mat-form-field class="search-input w-75" appearance="outline">
            <mat-label>Search</mat-label>
            <input matInput formControlName="searchControl" />
          </mat-form-field>
          <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(frmEOIList.get('searchControl')?.value ?? '')" id="btnSearch">
            <i class="bi bi-search fs-4"></i>
          </button>
          <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
            <i class="bi bi-arrow-clockwise fs-4"></i>
          </button>
        </div>
      </div>


      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-bordered table-hover" matTableResponsive
               matSortActive="createdOn" matSortDirection="desc" matSortDisableClear>
          <ng-container matColumnDef="RowNum">
            <th mat-header-cell *matHeaderCellDef>Sr.No</th>
            <td mat-cell *matCellDef="let el"> {{el.RowNum}} </td>
          </ng-container>
          <ng-container matColumnDef="EnterpriseCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>EOI Response Number</th>
            <td mat-cell *matCellDef="let el">
              <a class="text-primary no-underline" (click)="action(el.EnterpriseUniqueId,'view')" style="cursor: pointer;">{{ el.EnterpriseCode }}</a>
            </td>
            <td mat-cell *matCellDef="let el"> {{el.EnterpriseCode}} </td>
          </ng-container>
          <ng-container matColumnDef="EnterpriseName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Enterprise Name</th>
            <td mat-cell *matCellDef="let el"> {{el.EnterpriseName}} </td>
          </ng-container>
          <ng-container matColumnDef="UdyamRegistrationNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Udyam Registration Number</th>
            <td mat-cell *matCellDef="let el"> {{el.UdyamRegistrationNumber}} </td>
          </ng-container>
          <ng-container matColumnDef="DateOfEstablishment">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Of Establishment</th>
            <td mat-cell *matCellDef="let el"> {{el.DateOfEstablishment}} </td>
          </ng-container>
          <ng-container matColumnDef="CreatedOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Submission Date</th>
            <td mat-cell *matCellDef="let el"> {{el.CreatedOn}} </td>
          </ng-container>
          <ng-container matColumnDef="Sector">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Sector</th>
            <td mat-cell *matCellDef="let el"> {{el.Sector}} </td>
          </ng-container>
          <ng-container matColumnDef="Gender">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Gender</th>
            <td mat-cell *matCellDef="let el"> {{el.Gender}} </td>
          </ng-container>
          <ng-container matColumnDef="District">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>District</th>
            <td mat-cell *matCellDef="let el"> {{el.District}} </td>
          </ng-container>
          <ng-container matColumnDef="EnterpriseType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Enterprise Type</th>
            <td mat-cell *matCellDef="let el"> {{el.EnterpriseType}} </td>
          </ng-container>
          <ng-container matColumnDef="SocialCategory">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Social Category</th>
            <td mat-cell *matCellDef="let el"> {{el.SocialCategory}} </td>
          </ng-container>
          <ng-container matColumnDef="NoofEmployees">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>No Of Employees</th>
            <td mat-cell *matCellDef="let el"> {{el.NumberOfEmployees}} </td>
          </ng-container>
          <ng-container matColumnDef="TurnoverFY2024_25">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Turnover Financial Year 2024_25</th>
            <td mat-cell *matCellDef="let el"> {{el.TurnoverFY2024_25}} </td>
          </ng-container>
          <ng-container matColumnDef="downloadAll">
            <th mat-header-cell *matHeaderCellDef> Download Document </th>
            <td mat-cell *matCellDef="let el">
              <button mat-raised-button color="primary" class="" *ngIf="el.DownloadUdyamDocumentPath"
                      (click)="onDownload(el.DownloadUdyamDocumentPath, el.DownloadUdyamDocumentName); $event.preventDefault()">
                <i class="bi bi-download"></i> Download
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="responseDoc">
            <th mat-header-cell *matHeaderCellDef> Response Document </th>
            <td mat-cell *matCellDef="let el">
              <button mat-raised-button color="primary" class="" *ngIf="el.ResponseDocPath"
                      (click)="onDownload(el.ResponseDocPath, el.ResponseDocName); $event.preventDefault()">
                <i class="bi bi-download"></i> Download
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          Row shown when there is no matching data.
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data matching the filter</td>
          </tr>
        </table>
      </div>
      <mat-paginator #paginator
                     class="demo-paginator"
                     (page)="onPageChange($event)"
                     [length]="length"
                     [pageSize]="pageSize"
                     [showFirstLastButtons]="showFirstLastButtons"
                     [pageSizeOptions]="pageSizeOptions"
                     [hidePageSize]="hidePageSize"
                     [pageIndex]="pageIndex"
                     aria-label="Select page">
      </mat-paginator>
    </form>
  </div>
</div>

